import { SERVICE_AREAS } from "./site";

export const LANDING_PRODUCTS = [
    {
        keyword: "spray-foam-insulation",
        label: "Spray Foam Insulation",
        shortLabel: "Spray Foam",
        serviceId: "spray-foam",
        intro:
            "Open and closed-cell spray foam — the highest R-per-inch insulation on the market and the only product that air-seals as it insulates.",
        why: [
            "R-6.5 to R-7 per inch for closed-cell — the best you can get",
            "Acts as both insulation AND a continuous air barrier in one pass",
            "Won't sag, settle, or compress over time",
            "Code-compliant for finished basements, crawl spaces, and rim joists",
        ],
        whenToUse:
            "Best for rim joists, knee walls, conditioned attics, crawl spaces, and any cavity where you need maximum R-value in minimum thickness.",
    },
    {
        keyword: "blown-in-insulation",
        label: "Blown-In Insulation",
        shortLabel: "Blown-In",
        serviceId: "cellulose",
        intro:
            "Loose-fill cellulose or fiberglass blown to the exact depth needed for your target R-value. The fastest way to bring an underbuilt attic up to current code.",
        why: [
            "NICOR rebate eligible — most attic top-ups qualify for $1,000–$1,800",
            "Fills around joists, wires, and obstructions with zero gaps",
            "Cellulose is treated for fire and pest resistance",
            "Same-day install on most attics under 2,000 sq ft",
        ],
        whenToUse:
            "Best for accessible attics already framed and floored. The single highest-ROI insulation upgrade you can make on a 1950s–1990s home.",
    },
    {
        keyword: "attic-insulation",
        label: "Attic Insulation",
        shortLabel: "Attic",
        serviceId: "attics",
        intro:
            "Top-down attic systems — air seal first, then insulate to R-49 or R-60, then verify ventilation. The right way, every time.",
        why: [
            "Air sealing the attic floor BEFORE insulation (most companies skip this)",
            "Baffles installed to keep soffit-to-ridge airflow open",
            "Depth markers placed so the inspector can verify R-value at a glance",
            "NICOR & ComEd rebate paperwork filed on your behalf",
        ],
        whenToUse:
            "If you have ice dams in winter, hot upper floors in summer, or your attic insulation is below R-30 — this is where you start.",
    },
    {
        keyword: "fiberglass-batt-insulation",
        label: "Fiberglass Batt Insulation",
        shortLabel: "Fiberglass Batts",
        serviceId: "batt-fiberglass",
        intro:
            "Standard and high-density fiberglass batts sized to fit each cavity precisely. The right choice for new construction, additions, and finished basements.",
        why: [
            "No compression, no gaps, no fishmouths around wires or plumbing",
            "Vapor barriers installed per code for your climate zone",
            "R-13 to R-38 options available",
            "Fast install on accessible stud bays",
        ],
        whenToUse:
            "Best for new construction, additions, garages, and finished basements where stud bays are open and accessible.",
    },
    {
        keyword: "crawl-space-encapsulation",
        label: "Crawl Space Encapsulation",
        shortLabel: "Crawl Space",
        serviceId: "crawl-spaces",
        intro:
            "Heavy-duty vapor barrier, sealed vents, insulated walls, and a dehumidifier — the system that finally fixes cold floors and basement humidity.",
        why: [
            "20-mil reinforced liner sealed across the floor and up the walls",
            "Eliminates the moisture source that rots joists and grows mold",
            "Cold floors and seasonal humidity gone within 48 hours of install",
            "Dehumidifier integration available for problem crawls",
        ],
        whenToUse:
            "If your crawl space has standing water, a musty smell, visible insulation falling off the joists, or your first floor is cold all winter — encapsulate.",
    },
    {
        keyword: "dense-pack-insulation",
        label: "Dense-Pack Wall Insulation",
        shortLabel: "Dense Pack",
        serviceId: "dense-packing",
        intro:
            "High-density cellulose injected through small access holes — a real wall R-value upgrade with no drywall demolition.",
        why: [
            "3.5+ lbs/cu ft density — won't settle, no voids",
            "Drilled access holes are plugged and finished, not torn open",
            "Massive sound-deadening bonus on shared walls",
            "Ideal for bungalows, foursquares, and pre-1970s ranches",
        ],
        whenToUse:
            "If your exterior walls are cold to the touch in winter or you can hear every conversation through them — dense-pack fixes both.",
    },
    {
        keyword: "air-sealing",
        label: "Air Sealing",
        shortLabel: "Air Sealing",
        serviceId: "air-sealing",
        intro:
            "Tracking down every leak — top plates, can lights, attic hatches, rim joists, HVAC penetrations — and sealing them with the correct material at each point.",
        why: [
            "The single highest-ROI move in any older home",
            "Verified before-and-after with a calibrated blower door test",
            "Fire-rated foam at chases, caulk at framing, gasket kits at hatches",
            "Pairs with attic insulation for a real envelope upgrade",
        ],
        whenToUse:
            "Always. Insulation without air sealing is half the job. We air-seal first, then insulate.",
    },
    {
        keyword: "insulation-removal",
        label: "Insulation Removal",
        shortLabel: "Removal",
        serviceId: "insulation-removal",
        intro:
            "Safe, contained removal of contaminated, damaged, or just plain old insulation — including varmint-fouled loose fill — using HEPA-filtered vacuum systems.",
        why: [
            "Crew in full protective gear — gloves, goggles, respirators",
            "Specialized vacuums minimize dust and debris",
            "Material sealed in heavy-duty bags and disposed per local regulations",
            "Space cleaned and sanitized, ready for new insulation",
        ],
        whenToUse:
            "If your attic has had pest activity, water damage, mold, or vermiculite (asbestos risk) — remove before you re-insulate.",
    },
];

export function getLandingPages() {
    const pages = [];
    for (const product of LANDING_PRODUCTS) {
        for (const area of SERVICE_AREAS) {
            const stateLower = area.state.toLowerCase();
            const slug = `${product.keyword}-${area.slug}${
                area.slug.endsWith(`-${stateLower}`) ? "" : `-${stateLower}`
            }`;
            pages.push({
                slug,
                product,
                area,
                title: `${product.label} in ${area.city}, ${area.state} | HAZ Insulation`,
                description: `${product.label} services in ${area.city}, ${area.state} (${area.zip}). NICOR & ComEd rebate partner — up to $1,800 back. BPI-certified crew, 50+ five-star reviews.`,
                h1: `${product.label} in ${area.city}, ${area.state}`,
            });
        }
    }
    return pages;
}

export const LANDING_PAGES = getLandingPages();

export const LANDING_PAGE_MAP = LANDING_PAGES.reduce((acc, p) => {
    acc[p.slug] = p;
    return acc;
}, {});

export function getPopularLandingPages(limit = 12) {
    const priority = [
        "spray-foam-insulation",
        "blown-in-insulation",
        "attic-insulation",
        "crawl-space-encapsulation",
    ];
    const priorityCities = [
        "tinley-park",
        "orland-park",
        "frankfort",
        "mokena",
        "lemont",
        "homewood",
        "highland-in",
        "schererville-in",
    ];
    const out = [];
    for (const product of priority) {
        for (const city of priorityCities) {
            const match = LANDING_PAGES.find(
                (p) => p.product.keyword === product && p.area.slug === city
            );
            if (match) out.push(match);
            if (out.length >= limit) return out;
        }
    }
    return out;
}
